import { useFlowsSelector } from '../../../common/src/utils/globalVariables';
import { FlowsQuestionGroup } from '../types/FlowsTypes';
import useCurrentGroupPosition from './useCurrentGroupPosition';

const useCurrentGroup = (): FlowsQuestionGroup => {
  const currentGroupPosition = useCurrentGroupPosition();

  const currentGroup = useFlowsSelector(
    (state) => state.flows.questionnaire.groups[currentGroupPosition],
  );

  return currentGroup;
};

export default useCurrentGroup;
